import React from "react"
import {
  FormTableWrapper,
  TableBody,
  FormTableCell,
  TableHead,
  FormTableHeaderCell,
  FormTableRow,
  Fieldset,
  Legend,
} from "../../styles"
import FormInput from "../FormInput/FormInput"
import PropTypes from "prop-types"

import {
  getFieldIsInvalid,
  getValidationMessage
} from "../../../utils/utils"

function TableInput({ rows, columns, onChange, label, id }) {
  return (
    <Fieldset>
      {label && <Legend>{label}</Legend>}
      <FormTableWrapper>
        {columns && (
          <TableHead>
            <FormTableRow>
              <FormTableHeaderCell></FormTableHeaderCell>
              {columns.map((column) => (
                <FormTableHeaderCell key={`${id}-column-${column.subsection}`}>
                  {column.label}
                </FormTableHeaderCell>
              ))}
            </FormTableRow>
          </TableHead>
        )}
        {rows && (
          <TableBody>
            {rows.map((row) => (
              <FormTableRow key={row.field}>
                <FormTableHeaderCell>{row.label}</FormTableHeaderCell>
                {columns.map((column) => (
                  <FormTableCell
                    key={`${id}-row-${row.field}-cell-${column.subsection}`}
                  >
                    <FormInput
                      {...row}
                      id={row.field}
                      type={row.type ? row.type : "text"}
                      label={null}
                      onChange={(value) =>
                        onChange(row.field, column.subsection, value)
                      }
                      aria-label={`${row.label} for ${column.label}`}
                      value={row.values[column.subsection] || ""}
                      aria-invalid={getFieldIsInvalid(row.values[column.subsection],  row.type, {...row} )}
                      validationText={getValidationMessage(row.values[column.subsection], row.type, { ...row})}
                    />
                  </FormTableCell>
                ))}
              </FormTableRow>
            ))}
          </TableBody>
        )}
      </FormTableWrapper>
    </Fieldset>
  )
}

TableInput.propTypes = {
  /** An array of columns. Assumes that the table will have all cells in a row with the same type of field */
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      /** a unique subsection name for the header **/
      subsection: PropTypes.string,
      /** the display label for the header **/
      label: PropTypes.string,
    })
  ),
  /** An array of rows. Each row accepts tyhe below, but also can accept anything an input can accept, like aria attributes and so on */
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      /** A unique field name for the row **/
      field: PropTypes.string,
      /** The display label for that row */
      label: PropTypes.string,
      /** The type of input for that row */
      type: PropTypes.string,
      /** Field values - an object keyed by column id, e.g. column1: "the value", column2: "the other value" */
      values: PropTypes.object,
    })
  ),
  /** Called on change of value of an input. Gets called with the row ID, the column ID, and the new value */
  onChange: PropTypes.func,
}

export default TableInput
